import { useEffect } from 'react';
import { Card, Row } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import { useSelector } from 'react-redux';
const GuaranteeStatusResult = () => {
    const result = useSelector(state => state.guaranteeCardsReducer?.cardsStatus)
    const isLoading = useSelector(state => state.loading?.isLoading);
    useEffect(() => {
        document.body.classList = "notMain";
    }, [])
    return (
        <div className="container-fuid mt-2" style={{ padding: "12px" }}>
            <br />
            <Card>
                <Card.Header className="headerStyle">نتیجه استعلام کارت گارانتی</Card.Header>
                <Card.Body className='bodyStyle'>
                    {isLoading && <Loader type="BallTriangle" color="red" height={50} width={50} />}
                    {!isLoading && result && Array.isArray(result) &&
                        result.map((item, i) =>
                            <Card key={i} className="card-item col-md-5 mt-1" style={{ backgroundColor: i % 2 === 0 ? "#ba5322" : 'rgb(20 134 160)', margin: "auto" }}>
                                <Row>
                                    <div className="col-5">‏وضعیت کارت</div><div className="col-7">{item.GuarantyStatus}</div>
                                    <div className="col-5">‏شماره کارت</div><div className="col-7">{item.GuarantyCode}</div>
                                    <div className="col-5">‏شماره سریال</div><div className="col-7">{item.SerialNumber}</div>
                                    <div className="col-5">‏برند</div><div className="col-7">{item.HolderName}</div>
                                    <div className="col-5">‏تاریخ آغاز گارانتی</div><div className="col-7">{item.GuarantyStartDate}</div>
                                    <div className="col-5">‏تاریخ پایان گارانتی</div><div className="col-7">{item.GuarantyEndDate}</div>
                                </Row>
                            </Card>)
                    }
                    {!isLoading && (!result || !Array.isArray(result) || result.length === 0) &&
                        <div className="card card-item" style={{ backgroundColor: 'rgb(195 21 102)', alignItems: 'center', justifyContent: 'center', height: '150px' }}>
                            <div className="cardBody row">
                                کارتی با این مشخصات یافت نشد!
                            </div>
                        </div>
                    }
                </Card.Body>
            </Card>
        </div>
    )
}
export default GuaranteeStatusResult;